import axiosGo from "./axiosGo";

export const userApi = {
    getTierByUserID: (userId: string) => {
        const url = `user/api/v1/user-tier-config/${userId}`;
        return axiosGo.get(url);
    },
};
